import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const PhoneNotification: React.FC<IconComponentProps> = ({
  className,
}) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.74107 1.33929C1.50686 1.33929 1.33929 1.52215 1.33929 1.72047V13.2795C1.33929 13.4778 1.50686 13.6607 1.74107 13.6607H9.24107C9.47529 13.6607 9.64286 13.4778 9.64286 13.2795V9.60165C9.64286 9.23181 9.94266 8.93201 10.3125 8.93201C10.6823 8.93201 10.9821 9.23181 10.9821 9.60165V13.2795C10.9821 14.242 10.1903 15 9.24107 15H1.74107C0.791822 15 0 14.242 0 13.2795V1.72047C0 0.758081 0.791822 0 1.74107 0H5.75893C6.12876 0 6.42857 0.299809 6.42857 0.669643C6.42857 1.03948 6.12876 1.33929 5.75893 1.33929H1.74107ZM10.5804 0C9.7312 0 8.91477 0.330744 8.31121 0.922696C7.7073 1.51499 7.36607 2.32056 7.36607 3.16277V5.64567H6.83036C6.46052 5.64567 6.16071 5.94547 6.16071 6.31531C6.16071 6.68515 6.46052 6.98495 6.83036 6.98495H9.91071V7.36614C9.91071 7.73596 10.2105 8.03578 10.5804 8.03578C10.9502 8.03578 11.25 7.73596 11.25 7.36614V6.98495H14.3304C14.7002 6.98495 15 6.68515 15 6.31531C15 5.94547 14.7002 5.64567 14.3304 5.64567H13.7946V3.16277C13.7946 2.32056 13.4534 1.51499 12.8495 0.922696C12.2459 0.330744 11.4296 0 10.5804 0ZM4.95536 10.498C4.43759 10.498 4.01786 10.9176 4.01786 11.4355C4.01786 11.9532 4.43759 12.373 4.95536 12.373H6.02679C6.54455 12.373 6.96429 11.9532 6.96429 11.4355C6.96429 10.9176 6.54455 10.498 6.02679 10.498H4.95536Z"
      fill="currentColor"
    />
  </svg>
);
